// // import React, { useEffect, useState } from "react";
// // import { useSearchParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import Navbar from "../components/Navbar";
// // import Footer from "../components/Footer";

// // const BookingSuccess = () => {
// //   const [searchParams] = useSearchParams();
// //   const navigate = useNavigate();

// //   const jobId = searchParams.get("o");
// //   const sessionId = searchParams.get("session_id");

// //   const [loading, setLoading] = useState(true);
// //   const [statusMessage, setStatusMessage] = useState("Verifying your payment...");

// //   useEffect(() => {
// //     const verifyPayment = async () => {
// //       try {
// //         const response = await axios.post(
// //           "https://highwycombebites.com/api/booking/ConfirmDiningBooking",
// //           {
// //             bookingid: parseInt(jobId),
// //             sessionid: sessionId,
// //             paymentstatus: "Success",
// //           }
// //         );

// //         if (response.data?.success === "1") {
// //           setStatusMessage("Your reservation has been successfully confirmed.");
// //         } else {
// //           setStatusMessage("Payment received but booking confirmation failed.");
// //         }
// //       } catch (error) {
// //         setStatusMessage("Something went wrong while confirming booking.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     if (jobId && sessionId) verifyPayment();
// //   }, [jobId, sessionId]);

// //   return (
// //     <>
// //       <Navbar />

// //       <div className="payment-page success-bg">
// //         <div className="payment-card">

// //           <div className="status-icon success-icon">✓</div>

// //           <h1 className="payment-title">Payment Successful</h1>

// //           <p className="payment-subtitle">
// //             {loading ? "Please wait..." : statusMessage}
// //           </p>

// //           {!loading && (
// //             <div className="payment-actions">
// //               <button
// //                 className="primary-btn"
// //                 onClick={() => navigate("/")}
// //               >
// //                 Back to Home
// //               </button>

// //               <button
// //                 className="outline-btn"
// //                 onClick={() => navigate("/my-bookings")}
// //               >
// //                 View My Bookings
// //               </button>
// //             </div>
// //           )}

// //         </div>
// //       </div>

// //       <Footer />
// //     </>
// //   );
// // };

// // export default BookingSuccess;

// import React, { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const BookingSuccess = () => {
//   const [searchParams] = useSearchParams();
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState("");

//   const session_id = searchParams.get("session_id");
//   const orderid = searchParams.get("o");
//   const type = searchParams.get("t");
//   const device = searchParams.get("device");

//   useEffect(() => {
//     const confirmPayment = async () => {
//       try {
//         const response = await axios.post(
//           "https://highwycombebites.com/api/booking/confirmorder",
//           {
//             session_id: session_id,
//             orderid: orderid,
//             type: type,
//             devicetype: device,
//           }
//         );

//         if (response.data?.success === "1") {
//           setStatus("success");
//         } else {
//           setStatus("failed");
//         }
//       } catch (error) {
//         setStatus("failed");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (session_id) {
//       confirmPayment();
//     }
//   }, [session_id, orderid, type, device]);

//   if (loading) {
//     return (
//       <>
//         <Navbar />
//         <div style={containerStyle}>
//           <div style={cardStyle}>
//             <h2>Processing Payment...</h2>
//           </div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   return (
//     <>
//       <Navbar />
//       <div style={containerStyle}>
//         <div style={cardStyle}>
//           {status === "success" ? (
//             <>
//               <div style={iconSuccess}>✓</div>
//               <h2>Booking Confirmed 🎉</h2>
//               <p>Your payment was successful.</p>
//             </>
//           ) : (
//             <>
//               <div style={iconFail}>✕</div>
//               <h2>Payment Failed</h2>
//               <p>Please try again.</p>
//             </>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default BookingSuccess;

// const containerStyle = {
//   minHeight: "80vh",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   background: "#f4f6f9"
// };

// const cardStyle = {
//   background: "#fff",
//   padding: "40px",
//   borderRadius: "16px",
//   boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
//   textAlign: "center",
//   width: "400px"
// };

// const iconSuccess = {
//   fontSize: "60px",
//   color: "#2ecc71",
//   marginBottom: "20px"
// };

// const iconFail = {
//   fontSize: "60px",
//   color: "#e74c3c",
//   marginBottom: "20px"
// };

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BookingSuccess = () => {

  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");

  useEffect(() => {

    const confirmBooking = async () => {
      try {

        const session_id = searchParams.get("session_id");
        const orderid = searchParams.get("o");
        const type = searchParams.get("t");
        const device = searchParams.get("device");

        const response = await axios.post(
          "https://highwycombebites.com/api/booking/confirmorder",
          {
            session_id,
            orderid,
            type,
            devicetype: device
          }
        );

        console.log("Confirm Order Response:", response.data);

        if (response.data?.status === "1") {
          setStatus("success");
        } else {
          setStatus("failed");
        }

      } catch (error) {
        console.error(error);
        setStatus("failed");
      } finally {
        setLoading(false);
      }
    };

    confirmBooking();

  }, [searchParams]);

  return (
    <>
      <Navbar />

      <div className="booking-success-wrapper">

        {loading && (
          <div className="booking-loader">
            <div className="spinner"></div>
            <h2>Confirming your reservation...</h2>
            <p>Please wait while we verify payment</p>
          </div>
        )}

        {!loading && status === "success" && (
          <div className="booking-success-card">

            <div className="success-icon">✓</div>

            <h1>Booking Confirmed</h1>

            <p className="success-msg">
              Your payment was successful and your table has been reserved.
            </p>

            <div className="success-info">
              <p>🍽 Restaurant reservation confirmed</p>
              <p>📩 Confirmation email sent</p>
              <p>⏰ Please arrive 10 minutes early</p>
            </div>

            <div className="success-actions">
              <a href="/" className="home-btn">
                Go to Home
              </a>

              <a href="/dining" className="explore-btn">
                Explore Restaurants
              </a>
            </div>

          </div>
        )}

        {!loading && status === "failed" && (
          <div className="booking-fail-card">

            <div className="fail-icon">✕</div>

            <h1>Payment Verification Failed</h1>

            <p>
              We couldn't confirm your booking payment.
              Please contact support or try again.
            </p>

            <a href="/" className="retry-btn">
              Back to Home
            </a>

          </div>
        )}

      </div>

      <Footer />
    </>
  );
};

export default BookingSuccess;
